import React, { useState } from "react";
import displayToastMessage from "../../../components/Common/Alert/displayToastMessage";
import Edit from "../../../assets/images/editinput.svg";
import { Countries as countries } from "../../../../src/services/countries";
import "../../../../src/styles/userManagement.css";
import PasswordStrength from "../../Common/PasswordStrength/";
import view1 from "../../../assets/images/view 1.svg";
import closedeye from "../../../assets/images/icon-eye-closed.svg";
import { handleNotificationSubmit } from "../../Plan/notification/notification.js";
import PropTypes from 'prop-types'
import { Select } from "@appkit4/react-components/select";
import { Switch } from "@appkit4/react-components/switch";
import useHttp from "../../../hooks/useHttp.js";
import APIService from "../../../services/apiAxiosService.js";

export default function CreateUser(props) {
  let { SetTab, reloadData, createdUserList } = props;
  const [loading, setLoading] = useState(false);
  const [inputList, setInputList] = useState([{ organization: "", role: "" }]);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [country, setCountry] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorFirstUserMessage, setErrorFirstUserMessage] = useState("");
  const [errorLastUserMessage, setErrorLastUserMessage] = useState("");
  const [errorPhoneNoMsg, setErrorPhoneNoMsg] = useState("");
  const [errorCountryMsg, setErrorCountryMsg] = useState("");
  const [errorEmailMessage, setErrorEmailMessage] = useState("");
  const [errorPwdMessage, setErrorPwdMessage] = useState("");
  const [errorConfirmPwdMessage, setErrorConfirmPwdMessage] = useState("");
  const [isErrorMessageShown, setIsErrorMessageShown] = useState(false);
  const [validations] = useState("");
  const [validationsMatched, setValidationsMatched] = useState(false);
  const [isConfirmPassword, setIsConfirmPassword] = useState(true);
  const [confirmpassword, setConfirmPassword] = useState("");
  const [errorOrgroleMessage, setErrorOrgroleMessage] = useState("");
  const { sendRequest: userRegistration } = useHttp();
  const { sendRequest: handleNotificationSubmitAPI } = useHttp();
  const [defaultValidationMessages] = useState([
    {
      isError: false,
      message: "At least 8 characters",
    },
    {
      isError: false,
      message: "At least one number",
    },
    {
      isError: false,
      message: "At least one special character (!,.-?%$...)",
    },
    {
      isError: false,
      message: "At least one capital letter",
    },
    {
      isError: false,
      message: "At least one small letter",
    },
    {
      isError: false,
      message: "Both passwords need to be the same",
    },
  ]);

  const [adminCheck, setAdminCheck] = useState(false);
  const [validationMessagesTobeshown, setValidationMessagesTobeshown] =
    useState(defaultValidationMessages);

  const handleSubmit = async () => {
    //  setLoading(true)
    let obj = inputList[inputList.length - 1];
    let emailReg =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    let phoneRegExp =
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
    if (firstName.trim() === "") {
      setErrorFirstUserMessage("First Name is required");
      setIsErrorMessageShown(true);
      return false;
    }
    if (lastName.trim() === "") {
      setErrorLastUserMessage("Last Name is required");
      setIsErrorMessageShown(true);
      return false;
    }
    if (emailReg.test(email) === false) {
      setErrorEmailMessage("Email id is required in the correct format");
      setIsErrorMessageShown(true);
      return false;
    }
    if (phoneRegExp.test(phoneNumber) === false) {
      setErrorPhoneNoMsg("Phone Number is required");
      setIsErrorMessageShown(true);
      return false;
    }
    if (password.trim() === "") {
      setErrorPwdMessage("Password is required");
      setIsErrorMessageShown(true);
      return false;
    }
    if (confirmpassword.trim() === "") {
      setErrorConfirmPwdMessage("Confirm Password is required");
      setIsErrorMessageShown(true);
      return false;
    }
    if (validationsMatched !== true) {
      setErrorConfirmPwdMessage("");
      setIsErrorMessageShown(true);
      return false;
    }
    if (country.trim() === "") {
      setErrorCountryMsg("Country Selection is required");
      setIsErrorMessageShown(true);
      return false;
    }

    let payload = {
      firstname: firstName,
      lastname: lastName,
      phonenumber: phoneNumber,
      country: country,
      Email: email.toLowerCase(),
      Password: confirmpassword,
      is_admin: adminCheck,
      email:sessionStorage.getItem("email"),

    };
    try {
      userRegistration(APIService.userRegistration(payload), responseHandler,errorHandler);
    } catch (error) {
      console.log("Error", error);
      setLoading(false);
      let Msg = "User already exists, please create new user!";
      displayToastMessage(Msg, "error");
    }
  };

  const errorHandler = (err) => {
    displayToastMessage(err.response.data.MSG, "error");
    setLoading(false);
  }

  const responseHandler = (data) => {
    if (data.CODE) {
      reloadData();
      createdUserList();
      SetTab(0);
      setLoading(false);
      setFirstName("");
      setLastName("");
      setPhoneNumber("");
      setCountry("");
      setEmail("");
      setPassword("");
      setConfirmPassword("");
      setErrorConfirmPwdMessage("");
      displayToastMessage(data.MSG, "success");
      let notifData = {
        paramuserid: Number(sessionStorage.getItem("userId")),
        paramreqid: 1,
        paramcontent: "New user created",
        paramnextroleid: 2,
        paramcreatedby: Number(sessionStorage.getItem("roleId")),
        parammsgtype: data.MSG,
      };
      handleNotificationSubmitAPI(
        APIService.handleNotificationSubmit(notifData),
        () => {}
      );
    } else {

      let Msg = "Action failed. Please try again!";
      setLoading(false);
      displayToastMessage(Msg, "error");
    }
  };

  // handle input change
  const handleInputChange1 = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
    setErrorOrgroleMessage("");
  };

  const handleInputChange2 = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
    setErrorOrgroleMessage("");
  };

  // handle click event of the Remove button
  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };

  // handle click event of the Add button
  const handleAddClick = () => {
    let obj = inputList[inputList.length - 1];
    if (obj.organization === "" || obj.role === "") {
      return (
        setErrorOrgroleMessage("Please Enter orgRole Details"),
        setIsErrorMessageShown(true)
      );
    }
    setInputList([...inputList, { organization: "", role: "" }]);
  };
  const checkAllConditionsSatisfy = () => {
    let matched = true;
    const newValidationMessages = [];
    for (let obj of defaultValidationMessages) {
      if (obj.isError) {
        matched = false;
        newValidationMessages.push(obj);
      }
    }
    setValidationMessagesTobeshown(newValidationMessages);
    setValidationsMatched(matched);
  };
  const checkIfPasswordsMatch = (text, key) => {
    if (key === "password") {
      if (text === confirmpassword) {
        return true;
      }
    }
    if (key === "confirm-password") {
      if (text === password) {
        return true;
      }
    }
    return false;
  };
  const validate = (value, key) => {
    let res = [...defaultValidationMessages];
    if (value.length < 8) {
      res[0].isError = true;
    } else {
      res[0].isError = false;
    }

    if (value.search(/\d/) === -1) {
      res[1].isError = true;
    } else {
      res[1].isError = false;
    }

    if (value.search(/[^a-zA-Z0-9]/) === -1) {
      res[2].isError = true;
    } else {
      res[2].isError = false;
    }

    if (/([A-Z]+)/g.test(value)) {
      res[3].isError = false;
    } else {
      res[3].isError = true;
    }

    if (/([a-z]+)/g.test(value)) {
      res[4].isError = false;
    } else {
      res[4].isError = true;
    }

    if (key === "password") {
      const doesPasswordsMatch = checkIfPasswordsMatch(value, key);
      if (doesPasswordsMatch) {
        res[5].isError = false;
      } else {
        res[5].isError = true;
      }
    }
    if (key === "confirm-password") {
      const doesPasswordsMatch = checkIfPasswordsMatch(value, key);
      if (doesPasswordsMatch) {
        res[5].isError = false;
      } else {
        res[5].isError = true;
      }
    }
  };

  let validateInputFields = (value) => {
    let reg = /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/;
    if (value.match(reg)) {
      return true;
    } else {
      return false;
    }
  };
  let validatePassword = (value) => {
    let reg = /^[A-Za-z0-9 _!@#$%^&*.]*[A-Za-z0-9 @][A-Za-z0-9 _!@#$%^&*]*$/;
    if (value.match(reg)) {
      return true;
    } else {
      return false;
    }
  };

  // handle change for username
  const handleFirstName = (e) => {
    if (validateInputFields(e.target.value) || e.target.value === "") {
      setFirstName(e.target.value);
      setErrorFirstUserMessage("");
    } else {
      setErrorFirstUserMessage("Special characters are not allowed");
    }
  };

  const handleLastName = (e) => {
    if (validateInputFields(e.target.value) || e.target.value === "") {
      setLastName(e.target.value);
      setErrorLastUserMessage("");
    } else {
      setErrorLastUserMessage("Special characters are not allowed");
    }
  };
  const handlePhoneNumber = (e) => {
    if (validateInputFields(e.target.value) || e.target.value === "") {
      setPhoneNumber(e.target.value);
      setErrorPhoneNoMsg("");
    } else {
      setErrorPhoneNoMsg("Special characters are not allowed");
    }
  };

  const handleCountry = (e) => {
    setCountry(e);
    setErrorCountryMsg("");
  };

  const handlePassword = (e) => {
    if (validatePassword(e.target.value) || e.target.value === "") {
      validate(e.target.value, "password");
      setPassword(e.target.value);
      checkAllConditionsSatisfy();
      setErrorPwdMessage("");
    } else {
      setErrorPwdMessage("Special characters are not allowed");
    }
  };
  const handleConfirmPassword = () => {
    setIsConfirmPassword((prev) => !prev);
  };
  const handleConfirmPasswordChange = (e) => {
    if (validatePassword(e.target.value) || e.target.value === "") {
      validate(e.target.value, "confirm-password");
      setConfirmPassword(e.target.value);
      checkAllConditionsSatisfy();
      setErrorConfirmPwdMessage("");
    } else {
      setErrorConfirmPwdMessage("Special characters are not allowed");
    }
  };

  const handleReset = () => {
    SetTab(0);
  };
  const handelAdminSwitch = () => {
    setAdminCheck(!adminCheck);
  };

  const handleEmailValue = (e) => {
    if (e.target.value || e.target.value === "") {
      setEmail(e.target.value);
      setErrorEmailMessage("");
    } else {
      setErrorEmailMessage("Special characters are not allowed");
    }
  };

  return (
    <div className="create-vendor-form-container">
      {loading ? (
        <div className="a-loading a-primary a-m-10 a-loading-24 spinner-alignment"></div>
      ) : (
        <div className="App">
          <div className="row">
            <div className="col-sm-6">
              <div className="cv-input-field-container pt-0 pb-0">
                <label htmlFor="FirstNameCreateUser" className="cv-input-label">
                  First Name<span className="asterisk-required">*</span>
                </label>
                <input
                  className="cv-input-field pl-2"
                  type="text"
                  id="FirstNameCreateUser"
                  value={firstName}
                  placeholder="Please enter first name"
                  onChange={handleFirstName}
                  name="name"
                />
                <img alt="edit" src={Edit} className="edit-input" />
              </div>
              <div className="cv-input-field">
                <span
                  className="form-label errorMsg"
                  style={{
                    display: isErrorMessageShown ? "block" : "none",
                  }}
                >
                  {errorFirstUserMessage}
                </span>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="cv-input-field-container pt-0 pb-0">
                <label htmlFor="LastNameCreateUser" className="cv-input-label">
                  Last Name<span className="asterisk-required">*</span>
                </label>
                <input
                  className="cv-input-field"
                  type="text"
                  id="LastNameCreateUser"
                  value={lastName}
                  placeholder="Please enter last name"
                  onChange={handleLastName}
                  name="name"
                />
                <img alt="edit" src={Edit} className="edit-input" />
              </div>
              <div className="cv-input-field">
                <span
                  className="form-label errorMsg"
                  style={{
                    display: isErrorMessageShown ? "block" : "none",
                  }}
                >
                  {errorLastUserMessage}
                </span>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6 ">
              <div className="cv-input-field-container pt-0 pb-0">
                <label htmlFor="EmailCreateUser" className="cv-input-label">
                  Email <span className="asterisk-required">*</span>
                </label>
                <input
                  className="cv-input-field pl-2"
                  type="email"
                  id="EmailCreateUser"
                  value={email}
                  placeholder="Please enter email"
                  onChange={handleEmailValue}
                  name="Email"
                />
                <img alt="edit" src={Edit} className="edit-input" />
              </div>
              <div className="cv-input-field">
                <span
                  className="form-label errorMsg"
                  style={{
                    display: isErrorMessageShown ? "block" : "none",
                  }}
                >
                  {errorEmailMessage}
                </span>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="cv-input-field-container pt-0 pb-0">
                <label htmlFor="PhoneNumberCreateUser" className="cv-input-label">
                  Phone Number<span className="asterisk-required">*</span>
                </label>
                <input
                  className="cv-input-field"
                  type="number"
                  id="PhoneNumberCreateUser"
                  value={phoneNumber}
                  placeholder="Please enter phone number"
                  onChange={handlePhoneNumber}
                  name="PhoneNumber"
                />
                <img alt="edit" src={Edit} className="edit-input" />
              </div>
              <div className="cv-input-field">
                <span
                  className="form-label errorMsg"
                  style={{
                    display: isErrorMessageShown ? "block" : "none",
                  }}
                >
                  {errorPhoneNoMsg}
                </span>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <div className="cv-input-field-container pt-0 pb-0 ">
                <label htmlFor="PasswordCreateUser" className="cv-input-label">
                  Password<span className="asterisk-required">*</span>
                </label>
                <input
                  className="cv-input-field pl-2"
                  type="password"
                  id="PasswordCreateUser"
                  placeholder="Please enter password"
                  value={password}
                  onChange={(e) => handlePassword(e)}
                  name="Password"
                />
                <img alt="edit" src={Edit} className="edit-input" />
              </div>
              <PasswordStrength password={password} />
              <div className="">
                {validations && (
                  <div className="form-label errorMsg">{validations}</div>
                )}

                {password.length > 0 ? (
                  <div className="form-label errorMsg">
                    {validationMessagesTobeshown?.map((item, index) => {
                        return <li key={index}>{item.message}</li>;
                      })}
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="">
                <span
                  className="form-label errorMsg"
                  style={{
                    display: isErrorMessageShown ? "block" : "none",
                  }}
                >
                  {errorPwdMessage}
                </span>
              </div>
            </div>

            <div className="col-sm-6">
              <div className="cv-input-field-container pt-0 pb-0">
                <label htmlFor="ConfirmPasswordCreateUser" className="cv-input-label">
                  Confirm Password<span className="asterisk-required">*</span>
                </label>
                <input
                  className="cv-input-field"
                  id="ConfirmPasswordCreateUser"
                  type={isConfirmPassword ? "password" : "text"}
                  value={confirmpassword}
                  placeholder="Please enter confirm password"
                  onChange={(e) => handleConfirmPasswordChange(e)}
                  name="Password"
                />
                <input
                  type="image"
                  src={isConfirmPassword ? view1 : closedeye}
                  alt="new"
                  title={isConfirmPassword ? "Show Password" : "Hide Password"}
                  onClick={handleConfirmPassword}
                />
              </div>
              <div className="cv-input-field">
                <span
                  className="form-label errorMsg"
                  style={{
                    display: isErrorMessageShown ? "block" : "none",
                  }}
                >
                  {errorConfirmPwdMessage}
                </span>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <div className="cv-input-field-container pt-0 pb-0">
                <label className="cv-input-label">
                  Country<span className="asterisk-required">*</span>
                </label>
                <Select
                  className="cv-input-field"
                  dropdownRenderMode="portal"
                  searchable={true}
                  type="text"
                  value={country}
                  data={countries}
                  valueKey="code"
                  labelKey="name"
                  showSearchOnToggle={true}
                  placeholder="Select country"
                  onSelect={(e) => handleCountry(e)}
                  // dropdownClassName="dropdownHeight"
                  name="country"

                ></Select>
              </div>
              <div className="cv-input-field">
                <span
                  className="form-label errorMsg"
                  style={{
                    display: isErrorMessageShown ? "block" : "none",
                  }}
                >
                  {errorCountryMsg}
                </span>
              </div>
            </div>
            <div className="col-sm-6">
              <Switch
                checked={adminCheck}
                className="pt-3"
                onChange={handelAdminSwitch}
              >
                Admin User
              </Switch>
            </div>
          </div>
          <div className="options-container">
            <button
              className="cancel-button"
              type="reset"
              onClick={handleReset}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="save-button m-l-2"
              onClick={handleSubmit}
            >
              Save
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

CreateUser.propTypes = {
  SetTab: PropTypes.any, 
  reloadData: PropTypes.any, 
  createdUserList: PropTypes.any
}
